<template>
    <div :id="id"></div>
</template>

<script>
import gsap from 'gsap'

export default {
    name: 'falling-reward',

    props: {
        id: {
            type: String,
            default: 'falling-reward-container'
        }
    },

    mounted() {
        this.setAnimation()
    },

    methods: {
        setAnimation() {
            gsap.set('#' + this.id, { perspective: 600 })

            let total = 40
            let container = document.getElementById(this.id),
                w = window.innerWidth,
                h = window.innerHeight

            for (let i = 0; i < total; i++) {
                let elem = document.createElement('div')
                gsap.set(elem, {
                    attr: {
                        class: 'leave'
                    },
                    x: this.randomPos(0, w),
                    y: this.randomPos(-200, -150),
                    z: this.randomPos(-200, 200)
                })
                container.appendChild(elem)
                this.setAnimLeaves(elem, h)
            }
        },

        setAnimLeaves(elem, h) {
            gsap.to(elem, this.randomPos(6, 15), { y: h + 100, ease: 'none', repeat: -1, delay: -15 })
            gsap.to(elem, this.randomPos(4, 8), {
                x: '+=100',
                rotationZ: this.randomPos(0, 180),
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut'
            })
            gsap.to(elem, this.randomPos(2, 8), {
                rotationX: this.randomPos(0, 360),
                rotationY: this.randomPos(0, 360),
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut',
                delay: -5
            })
        },

        randomPos(min, max) {
            return min + Math.random() * (max - min)
        }
    }
}
</script>

<style lang="scss">
@mixin random-bgr() {
    background: rgb(random(255), random(255), random(255));
}

#falling-reward-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.leave {
    $num-colors: 50;
    $base-color: blue;
    $spectrum: 360deg;
    $offset: 50deg;

    width: 1rem;
    height: 0.5rem;
    position: absolute;

    @for $i from 0 to $num-colors {
        &:nth-child(#{$i}) {
            background: var(--ui-color);
        }
    }
}
</style>
